<template>
  <div class="deposit-order-amount c:col-center">
    <div class="deposit-order-amount-label">订金金额</div>
    <div class="deposit-order-amount-value">
      ￥{{ order.amount | filterPrice }}
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    order: Object,
  },
  computed: {},
  methods: {},
};
</script>

<style lang="less" scoped>
.deposit-order-amount {
  gap: 10/20rem;
  padding: 22/20rem 20/20rem;

  &-label {
    line-height: 12/20rem;
    font-size: 12/20rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #666;
  }
  &-value {
    line-height: 33/20rem;
    font-size: 33/20rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #19110b;
  }
}
</style>
